import React, { useState, useEffect } from "react";
import _ from "lodash";
import { locale_code } from "../../constants/i18n";
import { availableLanguages, i18n } from "../../config";

import { FormControl, Select, MenuItem, InputLabel, FormHelperText } from "@mui/material"

const LangSelectField = ({
  input: { onChange, value },
  initialValue,
  label,
  readOnly,
  meta,
  ...rest
}) => {

  const [availableItems, setAvailableItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(locale_code);

  const fetchAvailableItems = () => {
    setAvailableItems(availableLanguages());

    let defaultSelectedItem;
    if (value) {
      defaultSelectedItem = value;
      setSelectedItem(defaultSelectedItem);
    } else {
      defaultSelectedItem = selectedItem;
    }
    onChange(defaultSelectedItem);
  };

  const handleChange = (event) => {
    setSelectedItem(event.target.value);
    onChange(event.target.value);
  };

  useEffect(() => {
    fetchAvailableItems();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <FormControl style={{ width: "100%" }}>
        <InputLabel shrink htmlFor="">
        {(label || i18n.t('common:text.langselect_language'))}*
        </InputLabel>
        <Select
          value={selectedItem}
          onChange={handleChange}
          autoWidth={true}
          disabled={readOnly}
          {...rest}
        >
          {(!_.isEmpty(availableItems) &&
          availableItems.map((c) => {
            return (
              <MenuItem
                key={c.localeCode}
                value={c.localeCode}
              >{c.displayName}</MenuItem>
            );
          })) ||
          []}
        </Select>
      </FormControl>
      {meta.error && meta.touched && (
        <FormHelperText error={true} id="lang-select-error-text">
          {meta.error}
        </FormHelperText>
      )}
    </div>
  );
};

export default LangSelectField;
